import React, { Component } from 'react';
import PropTypes from 'prop-types';
import translations from '@shopify/polaris/locales/es.json'
import { Page, AppProvider } from '@shopify/polaris';

import { tModel } from '@utils';

const propTypes = {
  user: PropTypes.object.isRequired,
};


const UserShow = ({ user }) => (
  <AppProvider i18n={translations}>
    <Page
      title={ tModel("user") }
      primaryAction={{ content: 'Create User' }}
    >
      <p>
        Content of the User.
      </p>
      <p>
        First Name: {user.first_name}
      </p>
      <p>
        Last Name: { user.last_name }
      </p>
      <p>
        Email: { user.email }
      </p>
      <p>
        Role: { user.role}
     </p>
    </Page>
  </AppProvider>
)


UserShow.propTypes = propTypes;


export default UserShow;
